<template>
  <b-input
    ref="bInput"
    v-model="innerValue"
    :name="placeholder"
    :placeholder="placeholder"
  />
</template>

<script>
export default {
  name: 'ModernNumberInput',
  props: {
    value: {
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        let normalizedValue = String(value ?? '').replace(/\D/g, '');
        normalizedValue = normalizedValue === '' ? null : Number(normalizedValue);

        if (normalizedValue !== null && normalizedValue < this.min) {
          normalizedValue = this.min;
        }

        if (normalizedValue !== null && normalizedValue > this.max) {
          normalizedValue = this.max;
        }

        if (this.$refs.bInput && this.$refs.bInput.newValue !== normalizedValue) {
          this.$refs.bInput.newValue = normalizedValue;
        }

        if (normalizedValue !== this.value) {
          this.$emit('input', normalizedValue);
        }
      },
    },
  },
};
</script>
